import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "@/okta-config";

export const oktaAuthApi = new OktaAuth(oktaConfig.oidc);

// This prevents an unnecessary console warning when logging in/out.
oktaAuthApi.authStateManager.subscribe(() => {/* noop */});